import { useSelector } from 'react-redux';
import { useHasMounted } from '@common/Hooks/useHasMounted';
import { formatStatisticalNumberOutput } from '@helpers/customerHelpers';

export function useShopcartCount() {
    const hasMounted = useHasMounted();
    const count = useSelector(state => state.checkoutShopcart.cart.count);
    const formattedCount = formatStatisticalNumberOutput(count);

    return hasMounted ? formattedCount : 0;
}
